import { SurchargeComponent } from 'app/components/surcharge/surcharge.component';
import { Route } from '@angular/router';
import { AuthGuard } from 'app/common/services/auth-guard.service';

export const surchargeRoute: Route = {
    path: ':cityId/:clubNetId/:clubId/clubclients/:id/surcharge',
    component: SurchargeComponent,
    canActivate: [AuthGuard],
    data: { title: 'Доплата' }
};